import { ChurchLogo } from './ChurchLogo'

export default ChurchLogo
